export enum AnalyticsEvents {
  SignedOut = 'Signed Out',
}
